import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import connectRouter from 'components/Router/connect'
import { connect as connectStaticText } from 'components/StaticText/connect'
import compose from 'recompose/compose'
import { List, Map, fromJS } from 'immutable'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Link from 'components/Link'
import TileHero from 'components/TileHero'
import Vote, { SIZE_SMALL as VOTE_SIZE_SMALL } from 'components/Vote'
import { getBoundActions } from 'actions'
import { upstreamContextOnClick } from 'services/upstream-context'
import { isGaiaOriginal } from 'components/Tile.v2/utils'
import { CLICK_TO_DETAILS_PAGE_GA4_EVENT } from 'services/event-tracking'
import { TYPE_CONTENT_SERIES } from 'services/content-type'

function renderBottomMeta (props) {
  const { episodeCount, staticText, isGuide } = props
  let episodesText = episodeCount > 1
    ? staticText.getIn(['data', 'episodes'])
    : staticText.getIn(['data', 'episode'])

  if (isGuide) {
    episodesText = episodeCount > 1
      ? staticText.getIn(['data', 'lessons'])
      : staticText.getIn(['data', 'lesson'])
  }

  const bottomMetaItemClass = 'tile-series__meta-item'
  if (episodeCount) {
    return (
      <span className={bottomMetaItemClass}>
          {`${episodeCount} ${episodesText}`}
        </span>
    )
  }
  return null
}

const renderSeriesFlag = (props) => {
  const {
    staticText,
    isGuide,
    isEvent,
  } = props
  const gaiaOriginal = isGaiaOriginal(props)
  let flagText = staticText.getIn(['data', 'series'])

  if (isGuide) {
    flagText = staticText.getIn(['data', 'guide'])
  } else if (isEvent) {
    flagText = staticText.getIn(['data', 'event'])
  } else if (gaiaOriginal) {
    flagText = staticText.getIn(['data', 'gaiaOriginal'])
  }

  return <div className="tile-series__series-flag">{flagText}</div>
}

class TileSeries extends Component {
  //
  onClickSeriesTitle = (evt) => {
    const { props } = this
    const {
      id,
      title,
      uiLocation,
      mediaLanguage,
      upstreamContext,
      setUpstreamContext,
      setDefaultGa4Event,
    } = props

    // GA4 events
    setDefaultGa4Event(CLICK_TO_DETAILS_PAGE_GA4_EVENT.mergeDeep({
      content_id: id,
      content_name: title,
      content_type: TYPE_CONTENT_SERIES,
      media_language: mediaLanguage,
      is_featured_media: true,
      ui_location: uiLocation,
      ui_element: 'Tile',
    }))

    upstreamContextOnClick(evt, { upstreamContext, setUpstreamContext })
  }

  isSubscribed = () => {
    const { props } = this
    const { notifications, id } = props
    const userSubscriptions = notifications.getIn(['data', 'userSubscriptions'], List())
    const subscription = userSubscriptions.find((sub) => sub.get('contentId') === id, null, Map())
    return !!subscription.get('subscriber')
  }

  renderLabel = (value) => {
    const { props } = this
    const { staticText } = props
    const isSubscribed = this.isSubscribed()

    if (isSubscribed) {
      return <div className="tile-series__label">{staticText.getIn(['data', 'following'])}</div>
    }

    if (value) {
      return <div className="tile-series__label">{value}</div>
    }

    return null
  }

  renderTitle = (props) => {
    const { onClickSeriesTitle } = this
    if (props.title) {
      return (
        <Link
          to={props.url}
          className="tile-video__title"
          data-element="series-title"
          onClick={onClickSeriesTitle}
        >
          {props.title}
        </Link>
      )
    }

    return null
  }

  render () {
    const {
      props,
      renderLabel,
      renderTitle,
    } = this
    const {
      id,
      auth,
      feature,
      preview,
      image,
      url,
      showMoreInfo,
      toolTipComponent,
      onClickWatch,
      label,
      vote,
      voteDown,
      voteId,
      active,
      upstreamContext,
      displayMoreInfoButton,
      vertical = false,
      type,
      title,
      mediaLanguage,
      uiLocation,
    } = props
    const itemClass = Array.isArray(props.seriesTileClass)
      ? props.seriesTileClass.join(' ')
      : props.seriesTileClass
    const ga4EventData = fromJS({
      content_id: id,
      content_type: type,
      content_name: title,
      ui_location: uiLocation,
    })
    return (
      <div className={itemClass ? `tile-series ${itemClass}` : 'tile-series'}>
        {renderLabel(label)}
        <TileHero
          displayMoreInfoButton={displayMoreInfoButton}
          image={image}
          type={type}
          url={url}
          hasPlayIcon={false}
          auth={auth}
          preview={preview}
          feature={feature}
          showMoreInfo={showMoreInfo}
          toolTipComponent={toolTipComponent}
          active={active}
          onClickWatch={onClickWatch}
          upstreamContext={upstreamContext}
          vertical={vertical}
          title={title}
          mediaLanguage={mediaLanguage}
          id={id}
          parentSeriesId={id}
          parentSeriesTitle={title}
          uiLocation={uiLocation}
        />
        {
          !props.onlyShowHero
          && <React.Fragment>
            <div className="tile-series__top-meta">
              <Vote
                auth={auth}
                vote={vote}
                voteDown={voteDown}
                voteId={voteId}
                size={VOTE_SIZE_SMALL}
                className="vote--right-align vote--small"
                ga4EventData={ga4EventData}
              />
              {renderSeriesFlag(props)}
            </div>
            {renderTitle(props)}
            <div className="tile-series__bottom-meta">{renderBottomMeta(props)}</div>
          </React.Fragment>
        }
      </div>
    )
  }
}

TileSeries.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  app: ImmutablePropTypes.map.isRequired,
  active: PropTypes.bool,
  id: PropTypes.number,
  seriesTileClass: PropTypes.array,
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  label: PropTypes.string,
  seasonCount: PropTypes.number,
  episodeCount: PropTypes.number,
  vote: PropTypes.number,
  voteId: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  host: PropTypes.string,
  onlyShowHero: PropTypes.bool,
  showMoreInfo: PropTypes.bool.isRequired,
  toolTipComponent: PropTypes.element,
  preview: ImmutablePropTypes.map.isRequired,
  feature: ImmutablePropTypes.map.isRequired,
  onClickWatch: PropTypes.func,
  staticText: ImmutablePropTypes.map.isRequired,
  upstreamContext: ImmutablePropTypes.map,
  isGuide: PropTypes.bool,
}

TileSeries.defaultProps = {
  vote: 0,
}

export default compose(
  connectRouter(),
  connect(
    (state) => ({
      app: state.app,
      notifications: state.notifications,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setUpstreamContext: actions.upstreamContext.setUpstreamContext,
        setDefaultGa4Event: actions.eventTracking.setDefaultGa4Event,
      }
    },
  ),
  connectStaticText({ storeKey: 'tileSeries' }),
)(TileSeries)
